module.exports = __webpack_public_path__ + "img/677E93_36444D_99A9BA_435464-256px.4783152f.png";